import { RelateAnswer } from "./TopicRelateAnswer.type";

export const RELATE_ANSWER = {
  Y_Y: "y_y",
  Y_N: "y_n",
  N: "n",
};

type ColorOpacity = {
  COLOR: string;
  OPACITY?: number;
};

type KeyColorOpacity = (typeof RELATE_ANSWER)[keyof typeof RELATE_ANSWER];

export const RELATE_ANSWER_COLOR_OPACITY: {
  [key: KeyColorOpacity]: ColorOpacity;
} = {
  [RELATE_ANSWER.Y_Y]: { COLOR: "rgb(0, 0, 128)" },
  [RELATE_ANSWER.Y_N]: { COLOR: "rgba(0, 0, 128, 0.5)" },
  [RELATE_ANSWER.N]: { COLOR: "rgba(0, 128, 0)" },
};
